import { render } from "./CategoryCoursesMobile.vue?vue&type=template&id=47f5f9ef&scoped=true"
import script from "./CategoryCoursesMobile.vue?vue&type=script&lang=js"
export * from "./CategoryCoursesMobile.vue?vue&type=script&lang=js"

import "./CategoryCoursesMobile.vue?vue&type=style&index=0&id=47f5f9ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f5f9ef"]])

export default __exports__